export const options_density_modeMedium = "cv9HCe";
export const options_density_modeCompact = "I5fj2d";
export const options_density_modeRoomy = "B8Ejcc";
export const options_density_modeCozy = "Iw6Ir";
export const options_density_modeLarge = "iuKFAb";
export const options_density_modeSmall = "kJhmCb";
export default {options_density_modeMedium,options_density_modeCompact,options_density_modeRoomy,options_density_modeCozy,options_density_modeLarge,options_density_modeSmall};